/** @file QUAD_VERTEX_GLSL: the corner-quad vertex shader (positions come from CPU corners, no maths here). */

/**
 * Projects the CPU-computed (grown) corner with the camera's matrix and hands raster's per-quad constants to the
 * fragment shader unchanged (`flat`: no interpolation noise).
 */
export const QUAD_VERTEX_GLSL = `precision highp float;
attribute vec3 position;
attribute vec4 geomA;
attribute vec4 geomB;
attribute vec3 depth3;
attribute vec3 cut3;
attribute vec4 texRect;
uniform mat4 worldViewProjection;
flat varying vec4 vGeomA;
flat varying vec4 vGeomB;
flat varying vec3 vDepth;
flat varying vec3 vCut;
flat varying vec4 vRect;
void main(void) {
  vGeomA = geomA;
  vGeomB = geomB;
  vDepth = depth3;
  vCut = cut3;
  vRect = texRect;
  gl_Position = worldViewProjection * vec4(position, 1.0);
}
`;
